<mat-dialog-content>
  @if (isEditable) {
    <div class="w100 flex-between-center" style="margin-bottom: 20px">
      @if (data.notification.showTakeInCharge()) {
        <button class="buttonSize" color="primary" mat-flat-button
          matTooltip="{{'button.save' | translate}}"
          (click)="takeACharge()">
          {{ 'notification.takeCharge'|translate }}
        </button>
      }
      @if (data.notification.showAssignedTo()) {
        <button [matMenuTriggerFor]="menu"
          class="buttonSize" color="accent" mat-flat-button
          matTooltip="{{'button.save' | translate}}"
          (click)="openAssignedTo()">
          {{ 'notification.assignTo'|translate }}
        </button>
      }
      @if (data.notification.showCompleted()) {
        <button class="buttonSize" color="primary" mat-flat-button
          matTooltip="{{'button.save' | translate}}"
          (click)="complete()">
          {{ 'notification.complete'|translate }}
        </button>
      }
      @if (data.notification.showArchived()) {
        <button class="buttonSize" color="accent" mat-flat-button
          matTooltip="{{'button.save' | translate}}"
          (click)="archive()">
          {{ 'notification.archive'|translate }}
        </button>
      }
    </div>
  }
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        {{ data.notification.subject }}
      </mat-card-title>
      <mat-card-subtitle>
        {{ data.notification.last_edit_date|customDate:'medium'|async }}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      {{ data.notification.body }}
    </mat-card-content>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="w100 flex-between-center">
    <div>
      <button class="fab" color="accent" mat-flat-button
        matTooltip="{{'button.save' | translate}}"
        [mat-dialog-close]="undefined">
        <mat-icon>clear</mat-icon>
      </button>
      @if (isEditable) {
        @if (!data.notification.isRead) {
          <button class="fab" color="primary" mat-flat-button
            matTooltip="{{'button.save' | translate}}"
            (click)="markRead()">
            <mat-icon style="margin-right: 10px">drafts</mat-icon>
            {{ 'SensorEvent.markHasReaded'|translate }}
          </button>
        }
      }
    </div>
  </div>

</mat-dialog-actions>
<mat-menu #menu="matMenu">
  @if (loadingUser) {
    <mat-spinner [diameter]="20"></mat-spinner>
  }
  <form [formGroup]="form">
    @if (users) {
      <mat-selection-list [multiple]="false" formControlName="userAssignTo">
        @for (user of users; track user) {
          <mat-list-option [value]="user.objectId" (click)="$event.stopPropagation()">
            {{ user.nome }}
          </mat-list-option>
        }
      </mat-selection-list>
    }

  </form>
  <div class="w100 flex-center-center">
    <button mat-flat-button color="accent" style="margin-right: 10px">
      <mat-icon style="margin-right: 0">clear</mat-icon>
    </button>
    <button mat-flat-button color="primary">
      <mat-icon style="margin-right: 0" (click)="assignTo()">check</mat-icon>
    </button>
  </div>
</mat-menu>